import { render, staticRenderFns } from "./Historical.vue?vue&type=template&id=651e5b28&"
import script from "./Historical.vue?vue&type=script&lang=js&"
export * from "./Historical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports